
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySparDanger as ObiBuoySparDangerElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-spar-danger.js';
 
 
 

 
 export const ObiBuoySparDanger = createComponent({
   react: React,
   tagName: 'obi-buoy-spar-danger',
   elementClass: ObiBuoySparDangerElement,
   events: {
     
   }
  });
 
 